<script>
import { mapState } from "vuex";
import umatOpt from "@/data/umatOpt";
import umatData from "@/data/umat";

export default {
	name: "compUmatKomuni",
	props: ["triggerValidation"],
	data() {
		return {
			myOptions: {
				kriteria: umatOpt.kriteria,
				paroki: umatData.paroki,
				keuskupan: umatData.keuskupan,
			},
		};
	},
	computed: {
		isLoading() {
			return this.$store.state.isLoading;
		},
		...mapState({
			umatKomuniItem: (state) => state.umatKomuni.item,
		}),
	},
	watch: {
		// eslint-disable-next-line no-unused-vars
		triggerValidation: function (_newVal, _oldVal) {
			this.trigger();
		},
	},
	methods: {
		validateState(ref) {
			if (
				this.veeFields[ref] &&
				(this.veeFields[ref].dirty || this.veeFields[ref].validated)
			) {
				return !this.veeErrors.has(ref);
			}
			return null;
		},
		validateStateCustom(ref) {
			if (
				this.veeFields[ref] &&
				(this.veeFields[ref].dirty || this.veeFields[ref].validated)
			) {
				if (this.veeErrors.has(ref)) {
					return { "is-invalid": true };
				} else {
					return { "is-valid": true };
				}
			}
			return null;
		},
		trigger() {
			this.$emit("validate", this.$validator.validateAll());
			this.$validator.validateAll();
		},
	},
};
</script>

<template>
	<div class="form theme-form">
		<div class="row">
			<div class="col-md-6">
				<div class="form-group">
					<label>No Buku LSC <span class="text-danger">*</span></label>
					<b-form-input
						name="no_buku_lsc"
						v-model="umatKomuniItem.no_buku_lsc"
						v-validate="{ required: true }"
						:state="validateState('no_buku_lsc')"
						data-vv-as="No. Buku LSC"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("no_buku_lsc")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>No LSC <span class="text-danger">*</span></label>
					<b-form-input
						name="no_lsc"
						v-model="umatKomuniItem.no_lsc"
						v-validate="{ required: true }"
						:state="validateState('no_lsc')"
						data-vv-as="No. LSC"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("no_lsc")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Pastor <span class="text-danger">*</span></label>
					<b-form-input
						name="pastor"
						v-model="umatKomuniItem.pastor"
						v-validate="{ required: true }"
						:state="validateState('pastor')"
						data-vv-as="Pastor"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("pastor")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Tanggal Komuni <span class="text-danger">*</span></label>
					<b-form-input
						name="tgl_komuni"
						:state="validateState('tgl_komuni')"
						data-vv-as="Tanggal Komuni"
						v-validate="{ required: true }"
						v-model="umatKomuniItem.tgl_komuni"
						size="sm"
						type="date"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("tgl_komuni")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Keuskupan LSC <span class="text-danger">*</span></label>
					<vue-typeahead-bootstrap
						name="keuskupan_lsc"
						:class="validateStateCustom('keuskupan_lsc')"
						data-vv-as="Keuskupan LSC"
						v-validate="{ required: true }"
						v-model="umatKomuniItem.keuskupan_lsc"
						:minMatchingChars="1"
						:data="myOptions.keuskupan"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("keuskupan_lsc")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Paroki LSC <span class="text-danger">*</span></label>
					<vue-typeahead-bootstrap
						name="paroki_lsc"
						:class="validateStateCustom('paroki_lsc')"
						data-vv-as="Paroki LSC"
						v-validate="{ required: true }"
						v-model="umatKomuniItem.paroki_lsc"
						:minMatchingChars="1"
						:data="myOptions.paroki"
						size="sm"
					/>

					<b-form-invalid-feedback>{{
						veeErrors.first("paroki_lsc")
					}}</b-form-invalid-feedback>
				</div>
			</div>

			<div class="col-md-6">
				<div class="form-group">
					<label>Tempat <span class="text-danger">*</span></label>
					<b-form-input
						name="tempat"
						v-model="umatKomuniItem.tempat"
						v-validate="{ required: true }"
						:state="validateState('tempat')"
						data-vv-as="Tempat"
						size="sm"
					></b-form-input>

					<b-form-invalid-feedback>{{
						veeErrors.first("tempat")
					}}</b-form-invalid-feedback>
				</div>
			</div>
		</div>
	</div>
</template>

